import React from 'react';

export default function Icons(props) {
  return (
    <div className="flex items-center justify-center bg-button relative rounded-full w-[72px] h-[72px]">
      <div className="absolute">
        <img src={props.src} alt={props.alt} />
      </div>
    </div>
  );
}
